import {
	Button,
	ButtonGroup,
	DropdownFormInput,
	PhoneFormInput,
	TextFormInput,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import { FormProvider, useForm } from "react-hook-form";
import getChangeDates from "../../dateUtils";
import { useAuthContext } from "../auth/Auth.component";
import Conditions from "../inputs/conditions/Conditions";
import ZoneSelector from "../inputs/zone-selector/ZoneSelector";
import orderFormLanguageResource from "../order-form/lang-resource";
import type { FormData } from "../order-form/OrderForm";
import "../order-form/OrderForm.scss";

const PreviewComponent: React.FC = () => {
	const startDates = getChangeDates();
	const lang = useLanguageResource(orderFormLanguageResource);
	const { selectedCompany } = useAuthContext();

	const formMethods = useForm<FormData>({
		defaultValues: {
			employeeNumber: "1-34",
			firstName: "Kari",
			lastName: "Normann",
			phone: "+47 99 88 77 66",
			startDate: startDates[0],
			zoneFrom: "1",
			zoneTo: "1",
		},
	});

	const ticketOwnerFieldName = selectedCompany.ticketOwnerFieldName
		? selectedCompany.ticketOwnerFieldName
		: lang.inputs.employeeNumber;

	return (
		<div className="widget-order-form" data-test-id="preview-page">
			<FormProvider {...formMethods}>
				<form
					onSubmit={formMethods.handleSubmit(() => {})}
					data-test-id="order-form"
					className="order-form"
				>
					<PhoneFormInput
						name="phone"
						disabled={true}
						label={lang.inputs.phone}
					/>
					<div className="link-buttons">
						<button
							data-test-id="reset-button"
							type="button"
							onClick={() => {
								window.location.reload();
							}}
						>
							{lang.buttons.reset}
						</button>
					</div>
					<DropdownFormInput name="startDate" label={lang.inputs.startDate}>
						{startDates.map((date) => (
							<option key={date} value={date}>
								{date}
							</option>
						))}
					</DropdownFormInput>
					<TextFormInput
						name="firstName"
						required
						label={lang.inputs.firstName}
						maxLength={50}
					/>
					<TextFormInput
						name="lastName"
						required
						label={lang.inputs.lastName}
						maxLength={50}
					/>
					<TextFormInput
						name="employeeNumber"
						required
						label={ticketOwnerFieldName}
						maxLength={20}
					/>
					<ZoneSelector />
					<Conditions showCompanyTicket={true} showSubscription={false} />

					<ButtonGroup>
						<Button type="submit" skin="primary" disabled={true}>
							{lang.buttons.submitOrder}
						</Button>
					</ButtonGroup>
				</form>
			</FormProvider>
		</div>
	);
};

export default PreviewComponent;
